var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Model } from 'vue-property-decorator';
import CreateAreaDialog from '@/views/Users/Teacher/CreateAreaDialog';
import ErrorHandler from '@/support/ErrorHandler';
import { Teacher } from '@/models/Teacher';
import SelectFilter from '@/components/select-filter/SelectFilter';
import { UserSubject } from '@/models/UserSubject';
let Levels = class Levels extends Vue {
    constructor() {
        super(...arguments);
        this.selectedTeacherSubject = null;
        this.isAddingArea = false;
        this.userSubjects = [];
        this.teacherSubjects = [];
        this.selectedRoom = null;
        this.selectedLevelsMap = null;
    }
    get dialogOptions() {
        const payload = [];
        const userSubject = this.selectedTeacherSubject.userSubject;
        const createdItems = this.createPayload(userSubject);
        createdItems.forEach((createdItem) => {
            const currentLevels = [];
            if (!createdItem.levels) {
                return;
            }
            createdItem.levels.forEach((level) => {
                currentLevels.push(level.id);
            });
            const item = {
                subject: createdItem.subject,
                levels: currentLevels,
            };
            payload.push(item);
        });
        return {
            title: userSubject.name || this.$t('dialogOptions.confirmation').toString(),
            text: this.$tc('dialogOptions.delete', 1, { item: this.$t('dialogOptions.item.area') }).toString(),
            type: 'warning',
            buttons: {
                confirm: {
                    text: this.$t('dialogOptions.button.delete').toString(),
                    action: () => {
                        if (!userSubject) {
                            return;
                        }
                        new UserSubject()
                            .user(this.teacher)
                            .put(payload)
                            .then((subjects) => {
                            this.userSubjects = subjects;
                            this.parseToTeacherSubject();
                        });
                    },
                },
                cancel: {
                    text: this.$t('dialogOptions.button.cancel').toString(),
                    action: () => {
                        this.selectedTeacherSubject = null;
                    },
                },
            },
        };
    }
    mounted() {
        this.initialize();
    }
    parseToTeacherSubject() {
        this.teacherSubjects = [];
        const areas = this.$store.state.curriculum.subjects;
        this.userSubjects.forEach((userSubject) => {
            const area = areas.find((subject) => {
                return subject.id === userSubject.subject;
            });
            const parsedLevels = this.parseLevels(userSubject);
            const teacherSubject = {
                name: userSubject.name,
                color: area.color || '',
                userSubject,
                selectedLevels: parsedLevels,
                isEditing: false,
            };
            this.teacherSubjects.push(teacherSubject);
        });
    }
    deleteArea(teacherSubject) {
        this.selectedTeacherSubject = teacherSubject;
        this.$store.dispatch('openDialog', this.dialogOptions);
    }
    initialize() {
        if (!this.teacher.id) {
        }
        new UserSubject()
            .user(this.teacher.id || '')
            .all()
            .then((userSubjects) => {
            this.userSubjects = userSubjects;
            this.parseToTeacherSubject();
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    parseLevels(userSubject) {
        if (!userSubject.levels) {
            return [];
        }
        const levels = [];
        userSubject.levels.forEach((level) => {
            if (level.id) {
                levels.push(level.id);
            }
        });
        return levels;
    }
    update() {
        const payload = [];
        this.teacherSubjects.forEach((teacherSubject) => {
            const item = {
                subject: teacherSubject.userSubject ? teacherSubject.userSubject.subject : '',
                levels: teacherSubject.selectedLevels,
            };
            payload.push(item);
        });
        new UserSubject()
            .user(this.teacher)
            .put(payload)
            .then((subjects) => {
            this.initialize();
        });
    }
    createPayload(userSubject) {
        return this.userSubjects.filter((currentUserSubject) => {
            return currentUserSubject.id !== userSubject.id;
        });
    }
};
__decorate([
    Model('teacher', { default: () => new Teacher() }),
    __metadata("design:type", typeof (_a = typeof Teacher !== "undefined" && Teacher) === "function" ? _a : Object)
], Levels.prototype, "teacher", void 0);
Levels = __decorate([
    Component({
        components: {
            CreateAreaDialog,
            SelectFilter,
        },
    })
], Levels);
export default Levels;
